import styled from 'styled-components';
import { GhostButton } from "../../../Step1Setup/styles";

export const AccountNameWrap = styled.div`
    margin-bottom: 50px;
`

export const TitleTopSpace = styled.div`
    padding-top: ${props => props.paddingTop};
`

export const DisplayFlex = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: -26px;

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        flex-direction: column;
    }
`

export const GhostButtonWrap = styled(GhostButton)`
@media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
}
`